/**
 * 跳转app私信南方号
 */

import { env } from '../config'

const openAppEnv = env === 'pro' || !env ? '' : env

const openApp = ({ address, title = document.title || '' }, id, clickPosition) => {
  const options = {
    id: 12,
    shareType: 'share',
    title,
    isActivity: true,
    address,
    needClipboard: true,
    activityInfo: {
      activityId: id
    },
    openAppBigDataInfo: {
      url: window.location.href,
      clickPosition: clickPosition,
      origin: 3,
      sourceTag: 12,
      itemId: id,
      activityId: id
    }
  }
  console.log('--options--', options)
  window.OpenApp(options, openAppEnv)
}

export default openApp
